module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0909.7b8319ce.jpg";